import type { PutStepType } from '../../api';
import type { Node } from '../../model';

/**
 * Transform node to step parts with split participants and extracted group data
 * @param transformationFn - function that transforms node to step parts
 */
export const convertNodesToQueue =
  (transformationFn: (node: Node<any>) => [any, any]) => (nodes: Node[]) => {
    const result: any = {
      acceptors: [],
      signers: [],
      groups: [],
    };

    nodes.forEach((node, index) => {
      if (node.type === 'hold') {
        // this node should be handled in the previous node
        return;
      }

      if (!['accept', 'signe'].includes(node.type)) {
        // this node type is not supported in default queue
        return;
      }

      const holdAfter =
        index < nodes.length - 1 && nodes[index + 1].type === 'hold';

      const [queue, groups] = transformationFn(node);

      const step: PutStepType & { _path: string } = {
        holdAfter,
        queue,
        _path: node.id,
      };

      if (node.type === 'accept') {
        result.acceptors.push(step);
      }

      if (node.type === 'signe') {
        result.signers.push(step);
      }

      for (const group of groups) {
        result.groups.push({
          ...group,
          queueRole: node.type === 'accept' ? 'acceptor' : 'signer',
          queueStep: (node.type === 'accept'
            ? result.acceptors
            : result.signers
          ).length,
        });
      }
    });

    return result;
  };
